export interface ShowcasePanel {
    image: string;
    catchphrase: string;
    body: string;
}

export const PRODUCT_SHOWCASES: Record<string, ShowcasePanel[]> = {
    "1": [
        {
            image: "https://images.unsplash.com/photo-1558618666-fcd25c85cd64?auto=format&fit=crop&q=80&w=2000",
            catchphrase: "Darkness blooms at dusk",
            body: "An intoxicating journey through night gardens, where jasmine unfurls beneath a velvet sky.",
        },
        {
            image: "https://images.unsplash.com/photo-1559209172-0ff8f6d49ff7?auto=format&fit=crop&q=80&w=1600",
            catchphrase: "The scent of surrender",
            body: "Hand-blended with real jasmine absolute and aged amber resin. Each pour captures the precise moment the day surrenders to night.",
        },
        {
            image: "https://images.unsplash.com/photo-1583847268964-b28dc8f51f92?auto=format&fit=crop&q=80&w=1600",
            catchphrase: "Ritual in the half-light",
            body: "Light it at the close of day. Let the jasmine open slowly, the amber deepen, and the sandalwood settle into the room like a second silence.",
        },
    ],
    "2": [
        {
            image: "https://images.unsplash.com/photo-1542826438-bd32f43d626f?auto=format&fit=crop&q=80&w=2000",
            catchphrase: "Ancient wood, modern ritual",
            body: "Oud — one of the rarest materials in perfumery. Sourced from sustainable plantations, tempered with charred cedar and black pepper.",
        },
        {
            image: "https://images.unsplash.com/photo-1519098635131-4c8f806d1e82?auto=format&fit=crop&q=80&w=1600",
            catchphrase: "Depth without compromise",
            body: "The resin forms deep within the heartwood of Aquilaria trees — a centuries-long process that cannot be rushed. Neither can this scent.",
        },
        {
            image: "https://images.unsplash.com/photo-1538688525198-9b88f6f53126?auto=format&fit=crop&q=80&w=1600",
            catchphrase: "Let the smoke settle",
            body: "A candle for quiet evenings. For rooms that deserve gravitas. For people who understand that the most powerful things take time to reveal themselves.",
        },
    ],
    "3": [
        {
            image: "https://images.unsplash.com/photo-1505118380757-91f5f5632de0?auto=format&fit=crop&q=80&w=2000",
            catchphrase: "The coast at golden hour",
            body: "Crisp Italian bergamot lifted on a current of sea air, anchored by the cool mineral weight of salt and white musk.",
        },
        {
            image: "https://images.unsplash.com/photo-1601924994987-69e26d50dc26?auto=format&fit=crop&q=80&w=1600",
            catchphrase: "Pressed from the sun",
            body: "Bergamot has been cultivated on the Calabrian coast for over three centuries. We cold-press the zest for a freshness no synthetic can replicate.",
        },
        {
            image: "https://images.unsplash.com/photo-1507525428034-b723cf961d3e?auto=format&fit=crop&q=80&w=1600",
            catchphrase: "Light to its core",
            body: "Open a window. Strike the match. In seconds, the room fills with something that feels unmistakably like an escape.",
        },
    ],
    "4": [
        {
            image: "https://images.unsplash.com/photo-1531058020387-3be344556be6?auto=format&fit=crop&q=80&w=2000",
            catchphrase: "Petals pressed in time",
            body: "Damask rose absolute from Bulgaria's Valley of Roses — one of the most labour-intensive materials in fine perfumery — entwined with earthy patchouli and vanilla's warmth.",
        },
        {
            image: "https://images.unsplash.com/photo-1494972688394-4cc796f9e4c5?auto=format&fit=crop&q=80&w=1600",
            catchphrase: "The original luxury",
            body: "It takes 4,000 kilograms of rose petals to yield a single kilogram of absolute. Our Velvet Rose uses only natural materials — never synthetic rose.",
        },
        {
            image: "https://images.unsplash.com/photo-1512436991641-6745cdb1723f?auto=format&fit=crop&q=80&w=1600",
            catchphrase: "Soft, then deep",
            body: "The rose opens first — clean, dewy, unmistakable. Then the patchouli arrives. Then the vanilla. A candle that changes over the course of an evening.",
        },
    ],
    "5": [
        {
            image: "https://images.unsplash.com/photo-1448375240586-882707db888b?auto=format&fit=crop&q=80&w=2000",
            catchphrase: "After the rain, only silence",
            body: "Mature Mysore sandalwood, Scots pine, and the mineral scent of damp earth after rainfall — petrichor rendered in wax.",
        },
        {
            image: "https://images.unsplash.com/photo-1511497584788-876760111969?auto=format&fit=crop&q=80&w=1600",
            catchphrase: "Rooted in centuries",
            body: "Sandalwood takes thirty years to reach maturity. Ours is sourced from certified sustainable plantations in Mysore, where the world's finest sandalwood has grown since the 16th century.",
        },
        {
            image: "https://images.unsplash.com/photo-1542273917363-3b1817f69a2d?auto=format&fit=crop&q=80&w=1600",
            catchphrase: "The forest brought indoors",
            body: "Some candles perfume a room. This one transforms it. Light it, close the door, and let the room become a forest clearing at dusk.",
        },
    ],
    "6": [
        {
            image: "https://images.unsplash.com/photo-1495147466023-ac5c588e2e94?auto=format&fit=crop&q=80&w=2000",
            catchphrase: "Summer's last warmth",
            body: "Sun-ripened Provençal figs at the peak of their sweetness, dusted with cinnamon bark and wound with star anise — the last days of warmth made permanent.",
        },
        {
            image: "https://images.unsplash.com/photo-1601493700631-2b16ec4b4716?auto=format&fit=crop&q=80&w=1600",
            catchphrase: "Sweet, earthy, ancient",
            body: "The fig tree has been cultivated since antiquity. Its fruit — sweet, faintly animal, deeply nostalgic — forms the irreplaceable heart of this blend.",
        },
        {
            image: "https://images.unsplash.com/photo-1506905925346-21bda4d32df4?auto=format&fit=crop&q=80&w=1600",
            catchphrase: "Warmth without a fire",
            body: "Autumn in a vessel. A scent for shortening days, wool throws, and the particular pleasure of being indoors when the light outside turns amber.",
        },
    ],
};
